import React from 'react';
import MediaQuery from 'react-responsive';
import { useTheme } from 'telia-front-react';
const MediaQueryWrapper = (props) => {
    const [isMounted, setIsMounted] = React.useState(false);
    const { media } = useTheme();
    const remToPx = (rem) => rem * 16;
    const resolveBreakpoint = (value, maxWidth) => {
        if (typeof value === 'string' && value in media.width) {
            const { min, max } = media.width[value];
            const breakpointValue = maxWidth ? remToPx(parseFloat(max)) : remToPx(parseFloat(min));
            return breakpointValue;
        }
        return Number(value);
    };
    React.useEffect(() => {
        setIsMounted(true);
        return () => {
            setIsMounted(false);
        };
    }, []);
    if ('matchingContent' in props && 'unmatchingContent' in props) {
        const { matchingContent, unmatchingContent, fallbackContent, ...mediaQueryProps } = props;
        if (isMounted) {
            return (React.createElement(MediaQuery, { ...mediaQueryProps, minWidth: mediaQueryProps.minWidth && resolveBreakpoint(mediaQueryProps.minWidth), maxWidth: mediaQueryProps.maxWidth && resolveBreakpoint(mediaQueryProps.maxWidth, true) }, (matches) => (matches ? matchingContent : unmatchingContent)));
        }
        return (fallbackContent || matchingContent);
    }
    if ('content' in props && 'fallbackContent' in props) {
        const { content, fallbackContent, ...mediaQueryProps } = props;
        if (isMounted) {
            return (React.createElement(MediaQuery, { ...mediaQueryProps, minWidth: mediaQueryProps.minWidth && resolveBreakpoint(mediaQueryProps.minWidth), maxWidth: mediaQueryProps.maxWidth && resolveBreakpoint(mediaQueryProps.maxWidth, true) }, content));
        }
        return fallbackContent;
    }
};
export default MediaQueryWrapper;
